import { Stack, Switch } from '@mui/material';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import useConditionalGrid from 'Global/Hooks/useConditionalGrid';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import i18next from 'i18next';
import React, { useContext } from 'react';

const MoreColumSwitch = () => {
  const isGrid = useConditionalGrid([{}, {}]);
  const LesserGrid = localStorage.getItem('MoreRows');
  const GlobalConstants = useContext(GlobalContext);
  return (
    <React.Fragment>
      <Stack
        direction={
          i18next.language === 'en' ? 'row' : 'row-reverse'
        }
        alignItems="center"
        justifyContent="space-between"
        mt={'0.5em'}
      >
        <p>
          {FindLangKey(
            'general-settings-toggle-more-columns'
          )}
        </p>
        <Switch
          defaultChecked={JSON.parse(LesserGrid)}
          onChange={(e, checked) => {
            GlobalConstants.setMoreColumns(checked);
            localStorage.setItem(
              'MoreRows',
              JSON.stringify(checked)
            );
          }}
          sx={{
            fill: `${themeColors.ColorPrimary}`,
            marginLeft: isGrid ? '-.5em' : '',
          }}
        />
      </Stack>
    </React.Fragment>
  );
};

export default MoreColumSwitch;
